export var RecipeModuleText;
(function (RecipeModuleText) {
    RecipeModuleText["NoMealsForDayText"] = "Looks like there aren't any {meal_entity_name_plural} for this day. Select a day with some {meal_entity_name_plural}!";
    RecipeModuleText["NoRecipesAvailableText"] = "We didn't find any {programMealName} {meal_entity_name_plural} for this day... Check back later!";
    RecipeModuleText["UnexpectedErrorText"] = "Oops... Something unexpected happened while loading recipes.";
})(RecipeModuleText || (RecipeModuleText = {}));
